import classNames from 'classnames'
import styles from './index.module.less'
import { memo } from 'react'
// import { isNil } from 'lodash-es'
import { Badge, Tooltip } from 'antd'
import menuAciveIcon from '@/assets/menu-active-icon-v2.png';

const MenuItem = memo((props: any) => {
  const {
    className,
    active,
    onClick,
    styles: inlineStyle,
    icon,
    children,
    badge,
    badgeColor,
    collapsed,
    title,
    iconIndex,
    ...rest
  } = props
  return (
    <div
      {...rest}
      className={classNames(styles.menuItem, className, { [styles.active]: active })}
      onClick={onClick}
      style={{ ...inlineStyle?.wrap, marginTop: iconIndex === 0 ? 10 : 0, }}
    >
      <Tooltip placement="left" title={title} open={collapsed ? void 0 : false}>
        {/* 收起展示 数量 */}
        {!badge || collapsed ? (
          <Badge
            count={badge}
            // offset={[0, 0]}
            // size="small"
            color={badgeColor}
            style={{ zIndex: '5' }}
          >
            <div className={styles.menuIcon} style={inlineStyle?.icon}>
              {icon}
            </div>
          </Badge>
        ) : (
          <div className={styles.menuIcon} style={inlineStyle?.icon}>
            {icon}
          </div>
        )}
      </Tooltip>

      <div className={styles.menuText} style={inlineStyle?.text}>
        {children}
      </div>

      <img
        className={classNames(styles.activeIcon, { [styles.active]: active })}
        src={menuAciveIcon}
      ></img>

      {!badge || collapsed ? null : (
        <Badge
          count={badge}
          // offset={[0, 0]}
          // size="small"
          color={badgeColor}
          style={{ zIndex: '5' }}
        ></Badge>
      )}
    </div>
  )
})

export default MenuItem
